import { SortConfig, sortIndicator } from '../../utils/tableSort';
import './SortableTh.css';

type Props<K extends string> = {
  label: string;
  columnKey: K;
  sortConfig: SortConfig<K>;
  onSort: (key: K) => void;
};

const SortableTh = <K extends string>({
  label,
  columnKey,
  sortConfig,
  onSort,
}: Props<K>) => {
  const active = sortConfig.key === columnKey;
  return (
    <th
      scope="col"
      aria-sort={
        active
          ? sortConfig.direction === 'asc'
            ? 'ascending'
            : 'descending'
          : 'none'
      }
    >
      <button
        type="button"
        className="sortable-th-btn"
        onClick={(e) => {
          e.stopPropagation();
          onSort(columnKey);
        }}
      >
        {label}
        {sortIndicator(sortConfig, columnKey)}
      </button>
    </th>
  );
};

export default SortableTh;
